import { createClient } from '@supabase/supabase-js'

// Project ID from the Supabase connection
const SUPABASE_URL = 'https://lxrrnjheinzjiburaajc.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx4cnJuamhlaW56amlidXJhYWpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0MDAyODYsImV4cCI6MjA3NDk3NjI4Nn0.hs2V-Y0mQxgVVbC9DofWLeYSis3Hx08d396HFBFgnBM'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})